import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState, createContext, useContext } from "react";
import "./App.css";

import Header from "./components/Header";
import AdminDashboard from "./pages/AdminDashboard";
import Category from "./pages/Category";
import EditAdmin from "./pages/Company_Admin/RegisterPage";
import RegisterPage from "./pages/Company_Admin/RegisterPage";
import ViewAdmins from "./pages/Company_Admin/ViewAdmins";
import Currency from "./pages/Currency";
import LoginPage from "./pages/LoginPage";
import OrderingDashboard from "./pages/OrderingDashboard";
import PdcDashboard from "./pages/PdcDashboard";
import PurchaseOrder from "./pages/PurchaseOrder";
import PurchaseOrderForm from "./pages/PurchaseOrderForm";
import ViewPurchaseOrder from "./pages/ViewPurchaseOrder";
import Style from "./pages/Style_Management/Style";
import Supplier from "./pages/Supplier";
import RegisterCompany from "./pages/VCM_Admin/RegisterCompany";
import RegisterCompanyAdmins from "./pages/VCM_Admin/RegisterCompanyAdmins";
import VcmAdminDashboard from "./pages/VCM_Admin/VcmAdminDashboard";
import Companies from "./pages/VCM_Admin/ViewCompanies";
import ViewCompanyAdmins from "./pages/VCM_Admin/ViewCompanyAdmins";
import WarehouseGRN from "./pages/WarehouseGRN";
import WarehouseGRNDashboard from "./pages/WarehouseGRNDashboard";
import WarehouseIssuingDashboard from "./pages/WarehouseIssuingDashboard";
import CompanySettings from "./pages/Company_Admin/CompanySettings";
import ApprovePO from "./pages/ApprovePO";
import GRNDetails from "./components/GRNDetails";
import Location from "./pages/Location";
import AddGRN from "./pages/AddGRN";
import StyleAttributes from "./pages/Style_Management/StyleAttributes";
import WarehouseIssuing from "./pages/WarehouseIssuing";
import OrderDetails from "./pages/OrderDetails";
import VerifyCompanyAdmin from "./pages/VCM_Admin/VerifyCompanyAdmin";
import StockManagement from "./pages/StockManagement";
import ProductOffers from "./pages/ProductOffers";
import AddBanners from "./pages/WebsiteSettings/AddBanners";
import AddFooter from "./pages/WebsiteSettings/AddFooter";
import Tax from "./pages/Tax";
import AdminPasswordReset from "./pages/AdminPasswordReset";
import ProfileSettings from "./pages/ProfileSettings";
import GRNList from "./pages/GRNList";
import ViewVCMAdmins from "./pages/VCM_Admin/ViewVCMAdmins";
import VerifyVCMAdmin from "./pages/VCM_Admin/VerifyVCMAdmin";
import { AuthContext } from "./context/AuthContext";
import { updateFavicon, resetFavicon } from "./utils/faviconUtils";
import Sites from "./pages/Sites";
import SiteManagers from "./pages/SiteManagers";
import StockAllocation from "./pages/StockAllocation";
import StockAllocationHistory from "./pages/StockAllocationHistory";
import GeneralSettings from "./pages/WebsiteSettings/GenaralSettings";
import ManageMarketplace from "./pages/VCM_Admin/ManageMarketplace";
import ManageReturns from "./pages/VCM_Admin/ManageReturns";
import CodeGenerationSettings from "./pages/CodeGenerationSettings";
import ManageBusinessCategories from "./pages/VCM_Admin/ManageBusinessCategories";
import RawMaterials from "./pages/RawMaterials";
import RawMaterialsPO from "./pages/RawMaterialsPO";
import RowMaterialPOForm from "./pages/RowMaterialPOForm";
import ApprovePOForRawMaterials from "./pages/ApprovePOForRawMaterials";
import RawMaterialsGRN from "./pages/RawMaterialsGRN";
import AddRawMaterialGRN from "./pages/AddRawMaterialGRN";
import RawMaterialsGRNDetails from "./pages/RawMaterialsGRNDetails";
import RawMaterialsGRNHistory from "./pages/RawMaterialsGRNHistory";
// import FacebookSettings from "./pages/FacebookSettings";
// import FacebookAdManager from "./pages/FacebookAdManager";

// Create Sidebar Context for global sidebar state management
export const SidebarContext = createContext();

// Custom hook to manage body class, content, and header adjustment for sidebar
const useSidebarEffects = (sidebarCollapsed, isAuthenticated) => {
  useEffect(() => {
    const body = document.body;
    const mainContent = document.querySelector(".main-content");
    const header = document.querySelector(".main-header");

    // Helper to set left margin/width for header and main content
    const adjustLayout = () => {
      if (!isAuthenticated) {
        body.classList.remove("sidebar-collapsed");
        if (mainContent) mainContent.style.marginLeft = "0";
        if (header) header.style.left = "0";
        if (header) header.style.width = "100%";
        return;
      }
      if (window.innerWidth >= 992) {
        if (sidebarCollapsed) {
          body.classList.add("sidebar-collapsed");
          if (mainContent) mainContent.style.marginLeft = "80px";
          if (header) {
            header.style.left = "80px";
            header.style.width = "calc(100% - 80px)";
          }
        } else {
          body.classList.remove("sidebar-collapsed");
          if (mainContent) mainContent.style.marginLeft = "280px";
          if (header) {
            header.style.left = "280px";
            header.style.width = "calc(100% - 280px)";
          }
        }
      } else {
        body.classList.remove("sidebar-collapsed");
        if (mainContent) mainContent.style.marginLeft = "0";
        if (header) {
          header.style.left = "0";
          header.style.width = "100%";
        }
      }
    };

    adjustLayout();

    return () => {
      body.classList.remove("sidebar-collapsed");
      if (mainContent) mainContent.style.marginLeft = "0";
      if (header) header.style.left = "0";
      if (header) header.style.width = "100%";
    };
  }, [sidebarCollapsed, isAuthenticated]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const body = document.body;
      const mainContent = document.querySelector(".main-content");
      const header = document.querySelector(".main-header");
      if (!isAuthenticated) return;
      if (window.innerWidth < 992) {
        body.classList.remove("sidebar-collapsed");
        if (mainContent) mainContent.style.marginLeft = "0";
        if (header) {
          header.style.left = "0";
          header.style.width = "100%";
        }
      } else {
        if (sidebarCollapsed) {
          body.classList.add("sidebar-collapsed");
          if (mainContent) mainContent.style.marginLeft = "80px";
          if (header) {
            header.style.left = "80px";
            header.style.width = "calc(100% - 80px)";
          }
        } else {
          if (mainContent) mainContent.style.marginLeft = "280px";
          if (header) {
            header.style.left = "280px";
            header.style.width = "calc(100% - 280px)";
          }
        }
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarCollapsed, isAuthenticated]);
};

// Sidebar Context Provider Component
export const SidebarProvider = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const isAuthenticated = ![
    "/",
    "/login",
    "/verify-company-admin",
    "/admin-reset-password",
    "/verify-vcm-admin",
  ].includes(location.pathname);

  // Use the sidebar effects hook
  useSidebarEffects(sidebarCollapsed, isAuthenticated);

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed((prev) => !prev);
  };

  return (
    <SidebarContext.Provider
      value={{
        sidebarCollapsed,
        setSidebarCollapsed,
        toggleSidebarCollapse,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to use sidebar context
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};

function App() {
  const location = useLocation();
  const { userData } = useContext(AuthContext);

  // Update favicon based on company logo
  useEffect(() => {
    if (userData && userData.company_code) {
      updateFavicon(userData.company_code);
    } else {
      resetFavicon();
    }
  }, [userData]);

  // Hide header on specific routes
  const hideHeaderRoutes = [
    "/",
    "/login",
    "/verify-company-admin",
    "/admin-reset-password",
    "/verify-vcm-admin",
  ];
  const hideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <SidebarProvider>
      {/* Add a class to the header for targeting in JS */}
      {!hideHeader && (
        <div
          className="main-header"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1030,
          }}
        >
          <Header />
        </div>
      )}
      <div
        className={`main-content ${!hideHeader ? "with-header" : ""}`}
        style={{ paddingTop: !hideHeader ? 64 : 0 }}
      >
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/vcm-admin-dashboard" element={<VcmAdminDashboard />} />
          <Route path="/vcm-admin/register-company-admins/*" element={<RegisterCompanyAdmins />} />
          <Route path="/vcm-admin/edit-company-admins/:id" element={<RegisterCompanyAdmins />} />
          <Route path="/vcm-admin/view-companies" element={<Companies />} />
          <Route path="/vcm-admin/view-company-admins/:companyCode" element={<ViewCompanyAdmins />} />
          <Route path="/vcm-admin/register-company" element={<RegisterCompany />} />
          <Route path="/vcm-admin/edit-company/:id" element={<RegisterCompany />}/>
          <Route path="/vcm-admin/view-vcm-admins" element={<ViewVCMAdmins />} />
          <Route path="/vcm-admin/manage-marketplace" element={<ManageMarketplace />} />
          <Route path="/vcm-admin/manage-returns" element={<ManageReturns />} />
          <Route path="/vcm-admin/manage-business-categories" element={<ManageBusinessCategories />} />

          <Route path="ViewAdmins" element={<ViewAdmins />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="EditAdmins/:id" element={<EditAdmin />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="/OrderingDashboard/*" element={<OrderingDashboard />} />
          <Route path="/PdcDashboard/*" element={<PdcDashboard />} />
          <Route path="/WarehouseGRNDashboard/*" element={<WarehouseGRNDashboard />} />
          <Route path="/WarehouseIssuingDashboard/*" element={<WarehouseIssuingDashboard />} />
          <Route path="users" element={<ViewAdmins />} />
          <Route path="category" element={<Category />} />
          <Route path="products" element={<Style />} />
          <Route path="/products/:style_number/attributes" element={<StyleAttributes />} />
          <Route path="/raw-materials" element={<RawMaterials />} />

          <Route path="/warehouse/grn" element={<WarehouseGRN />} />
          <Route path="/warehouse/add-grn" element={<AddGRN />} />
          <Route path="/warehouse/add-grn/:po_number" element={<AddGRN />} />
          <Route path="/warehouse/grn-details/:grn_id" element={<GRNDetails />} />

          <Route path="/warehouse/raw-materials-grn" element={<RawMaterialsGRN />} />
          <Route path="/warehouse/add-raw-materials-grn" element={<AddRawMaterialGRN />} />
          <Route path="/warehouse/add-raw-materials-grn/:po_number" element={<AddRawMaterialGRN />} />
          <Route path="/warehouse/raw-materials-grn-details/:grn_id" element={<RawMaterialsGRNDetails />} />
          <Route path="/warehouse/raw-materials-grn-history" element={<RawMaterialsGRNHistory />} />

          <Route path="/warehouse/allocate-stock" element={<StockAllocation />} />
          <Route path="/warehouse/allocate-stock/details/:gtn_id" element={<StockAllocation />} />
          <Route path="/warehouse/allocate-stock/history" element={<StockAllocationHistory />} />

          <Route path="/finance/currency" element={<Currency />} />
          <Route path="/finance/supplier" element={<Supplier />} />

          <Route path="/merchandising/po" element={<PurchaseOrder />} />
          <Route path="/merchandising/po/new" element={<PurchaseOrderForm />} />
          <Route path="/merchandising/po/:po_number/edit" element={<PurchaseOrderForm />} />
          <Route path="/merchandising/po/:po_number/view" element={<ViewPurchaseOrder />} />
          <Route path="/merchandising/raw-materials-po" element={<RawMaterialsPO />} />
          <Route path="/merchandising/raw-materials-po/create" element={<RowMaterialPOForm />} />
          <Route path="/merchandising/raw-materials-po/:po_number/edit" element={<RowMaterialPOForm />} />
          <Route path="/merchandising/raw-materials-po/:po_number/view" element={<RowMaterialPOForm />} />

          <Route path="/accounting/tax" element={<Tax />} />

          <Route path="/company-settings" element={<CompanySettings />} />
          <Route path="/website-settings/banners" element={<AddBanners />} />
          <Route path="/website-settings/footer" element={<AddFooter />} />
          <Route path="/website-settings/general" element={<GeneralSettings />} />
          <Route path="/code-generation-settings" element={<CodeGenerationSettings />} />

          <Route path="/approve-po" element={<ApprovePO />} />
          <Route path="/approve-po-for-raw-materials" element={<ApprovePOForRawMaterials />} />

          <Route path="/warehouse/issuing" element={<WarehouseIssuing />} />
          <Route path="/order-details/:order_id" element={<OrderDetails />} />
          <Route path="/verify-company-admin" element={<VerifyCompanyAdmin />} />
          <Route path="/warehouse/stock" element={<StockManagement />} />
          <Route path="/warehouse/offers" element={<ProductOffers />} />
          <Route path="/warehouse/grn/list" element={<GRNList />} />

          {/* <Route path="/marketing/facebook-settings" element={<FacebookSettings />} />
          <Route path="/marketing/facebook-ads" element={<FacebookAdManager />} /> */}

          <Route path="/admin-reset-password" element={<AdminPasswordReset />} />
          <Route path="/profile-settings" element={<ProfileSettings />} />
          <Route path="/verify-vcm-admin" element={<VerifyVCMAdmin />} />

          <Route path="/manage-sites" element={<Sites />} />
          <Route path="/manage-branches" element={<Sites />} />
          <Route path="/manage-plants" element={<Sites />} />
          <Route path="/manage-branch-managers/:siteId" element={<SiteManagers />} />
          <Route path="/manage-plant-managers/:siteId" element={<SiteManagers />} />
          <Route path="/manage-locations/:plantId" element={<Location />} />
          <Route path="/manage-warehouse-locations" element={<Location />} />
        </Routes>
      </div>
    </SidebarProvider>
  );
}

export default App;
